<template>
  <PageVenueFilter
    :value="venueId"
    @input="$store.dispatch('pos/general/selectVenueId', $event)"
  >
    <AssignedSalesProducts v-if="venueId" :venueId="venueId" />
  </PageVenueFilter>
</template>

<script>
import { mapGetters } from "vuex";
import PageVenueFilter from "@/components/Custom/PageVenueFilter.vue";
import AssignedSalesProducts from "./AssignedSalesProducts.vue";

export default {
  components: {
    PageVenueFilter,
    AssignedSalesProducts,
  },
  computed: {
    ...mapGetters({
      venueId: "pos/general/selectedVenueId",
    }),
  },
};
</script>